import { KeyboardArrowDown } from "@mui/icons-material";
import { format } from "date-fns";
import Skeleton from "react-loading-skeleton";
import { useDispatchTypeLabel } from "~/hooks/language";
import { useOrderingOptions } from "~/hooks/ordering-options";
import { Location, Page, TimeSlot } from "~/types";
import { Box } from "../Box/Box";
import { Text } from "../Text/Text";
import { handleSelectKeyDown } from "~/utils/accessibility";

export function OrderingOptionsButton(props: {
  location: Location;
  page: Page | null;
  onClickDetails: () => void;
}): React.ReactElement {
  const {
    dispatchOption,
    timeSlot: selectedTimeslot,
    // Could use the label from here if we fallback to PICK_UP inside
    // dispatchOptionLabel,
  } = useOrderingOptions(props.location.ref);

  // NOTE: Defaulting the label to Pick Up if there is no dispatch option selected, or none available
  // This is the happy path so the screen doesn't show an irrelevant loading state.
  // TODO: We should prompt user if none selected, right?
  const { label: dispatchLabel } = useDispatchTypeLabel(
    dispatchOption || "PICK_UP",
  );

  return (
    <Box
      onClick={props.onClickDetails}
      flexDirection="row"
      display="flex"
      alignItems="center"
      cursor="pointer"
      background="white"
      paddingY="2"
      paddingX="2"
      height="touchable"
      tabIndex={0}
      onKeyDown={(e) => handleSelectKeyDown(e, props.onClickDetails)}
      style={{
        borderRadius: "4px",
        boxShadow: "0px 0px 8px rgba(0,0,0,0.25)",
        // if you change this, change the location name max width too (below)
        maxWidth: 270,
      }}
    >
      <Box display={"flex"} flexDirection={"column"}>
        <Box display={"flex"} flexDirection={"row"}>
          <Text
            size="small"
            color={!dispatchOption ? "neutral-500" : "neutral-900"}
            transform="uppercase"
          >
            {dispatchLabel || <Skeleton width={75} />}
          </Text>
          <Box paddingLeft="1">
            <Text size="small">
              {selectedTimeslot
                ? collectionTimeSlotsSelectedDateFormat(selectedTimeslot)
                : "ASAP"}
            </Text>
          </Box>
        </Box>
        <Box display={"flex"} flexDirection={"row"} style={{ maxWidth: 220 }}>
          <Text truncate={true} priority="low" transform="uppercase">
            {props.location.name || <Skeleton width={150} />}
          </Text>
        </Box>
      </Box>
      <Box
        style={{
          alignContent: "center",
          alignItems: "center",
        }}
        height="full"
        flexDirection={"column"}
        paddingLeft="2"
      >
        <KeyboardArrowDown />
      </Box>
    </Box>
  );
}

function collectionTimeSlotsSelectedDateFormat(timeSlot: TimeSlot): string {
  const startDate = format(new Date(timeSlot.startTime), "ccc, d MMM");
  const startTime = format(new Date(timeSlot.startTime), "h:mm a");

  return `${startDate}, ${startTime}`;
}
